import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { PlatformType } from "../../../types/baseTypes";

import styles from "./Socials.module.scss";
import { ReactSVG } from "react-svg";
import { CustomLink } from "@/components/CustomLink";

interface SocialsProps {
  platforms: PlatformType;
  headline?: string;
  showName?: boolean;
}

export const Socials = ({
  platforms,
  headline,
  showName = false,
}: SocialsProps) => {
  const { getLabel } = useGlobalContext();

  return (
    <div className={`${styles["socials-col"]}`}>
      {headline && (
        <span className="footer-headline h3 is-block">{headline}</span>
      )}
      <div
        className={
          styles.socials +
          ` ${showName === false ? styles["flow-wrap"] : ""} footer-socials`
        }
      >
        {Array.isArray(platforms) &&
          platforms.length > 0 &&
          platforms.map((social, index) => {
            if (social?.name) {
              const arialLabel = getLabel("aria_label_socials")?.replace(
                `"$title_social_network"`,
                social.name,
              );

              return (
                social.link &&
                social.show_footer && (
                  <CustomLink
                    id={`social-${index}`}
                    className={styles.social + " footer-link"}
                    target="_blank"
                    rel="noopener"
                    aria-label={arialLabel}
                    key={index}
                    href={social.link}
                  >
                    {social?.icon?.url && (
                      <ReactSVG
                        width={20}
                        height={20}
                        src={social.icon?.url || ""}
                        wrapper={"svg"}
                        role="link"
                        beforeInjection={(svg) => {
                          svg.setAttribute("alt", `${social.name} Icon`);
                          svg.setAttribute("title", `${social.name} Icon`);
                          svg.setAttribute("aria-label", `${social.name} Icon`);
                        }}
                        aria-label={`${social.name} link`}
                      />
                    )}

                    {showName && <p className="footer-link">{social.name}</p>}
                  </CustomLink>
                )
              );
            }
          })}
      </div>
    </div>
  );
};
